import SplitMaxPointsRewardCalculationTypeEditor from "../../../pages/actionModules/ActionModuleEditor/RewardCalculationEditor/SplitMaxPointsRewardCalculationTypeEditor";
import { RewardCalculationTypeDefinition } from "../actionModule";
import { RewardCalculationType } from "./rewardCalculationType";

export const SplitMaxPointsRewardCalculationType: RewardCalculationTypeDefinition = {
    name: "actionModules.rewardCalculationType.splitMaxPoints.name",
    defaultValue: {},
    type: RewardCalculationType.SplitMaxPointsCalculationType,
    editor: () => <SplitMaxPointsRewardCalculationTypeEditor />
};